import styled from 'styled-components';

export const Title = styled.h2`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: var(--color-text-muted);
  margin: 0 0 10px;
  text-align: center;
`;
